import Chip from '@mui/material/Chip'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import ErrorIcon from '@mui/icons-material/Error'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'

type AccreditationStatusBadgeProps = {
  status: 'pending' | 'verified' | 'rejected' | null
}

const AccreditationStatusBadge = ({
  status
}: AccreditationStatusBadgeProps) => {
  switch (status) {
    case 'pending':
      return (
        <Chip
          icon={<HourglassEmptyIcon />}
          label='Verification in progress'
          color='warning'
          size='small'
          variant='outlined'
        />
      )
    case 'verified':
      return (
        <Chip
          icon={<CheckCircleIcon />}
          label='Verified diver'
          color='success'
          size='small'
          variant='outlined'
        />
      )
    case 'rejected':
      return (
        <Chip
          icon={<ErrorIcon />}
          label='Verification unsuccessful'
          color='error'
          size='small'
          variant='outlined'
        />
      )
    default:
      return (
        <Chip
          icon={<HelpOutlineIcon />}
          label='Not verified'
          color='default'
          size='small'
          variant='outlined'
        />
      )
  }
}

export default AccreditationStatusBadge
